/** formatInfo()
 *  Loop thru all rows and format each field for display in the info tool
 *  @param {Array} records (required)
 *  @param {Array <array>} format [[optional-label], [optional-function]] OR new form: {} with parameters
 *  @param {String} heading (optional)
 *  @param {String} footer (optional)
 *  @return {Element} Div with a <ul> for each row in "records"

   + label:  value                     // typical
   + label:  value   function-result   // label: value <a href=...>
   +         value                     // e.g. '1.0 acres'
   +         value   function-result   // e.g. '1.0 acres' '43,560 sq ft'
   +                 function-result   // function returns something and is displayed w/o a label
   +                 function rtn=''   // function returns nothing e.g. geometry
   ? label:          function-result   // Not handled, how to do this?
 */

export default function(records, format, heading, footer) {

  let ul, li, para, span, content;
  let editable, action;
  let formata;  // format array
  if (!records) return;

  // if format isn't an array then it's the new form which is an {}
  if (Array.isArray(format)) { // original form, format is an [] of [label, function] for each field
    formata = format; // format array
  } else {  // new form, format is an {} of parameters, optionally containing the old sytle format []
    heading = format.heading;
    footer = format.footer;
    editable = format.editable;
    formata = format.format; // format array
    action = format.action;
  }

  content = document.createElement('div');

  if (heading) {
    if (heading instanceof HTMLElement) {
      content.appendChild(heading);
    } else {
      para = document.createElement('p');
      para.className = 'infocount';
      para.innerHTML = heading;
      content.appendChild(para);
    }
  }

  // Also worth looking at editableAttributes() justified-labels


  // editable returns a <div> of <inputs> for ALL format elements
  // non-editable returns a <ul> of only format elements (keys) that have a value

  if (editable) {
    records.forEach(function(row) {
      let form = document.createElement('form');
      form.className = 'justified-labels';
      // margin-top, margin-right, margin-bottom, and margin-left
      // border-bottom: 1px solid;
      form.setAttribute('style', 'background-color: beige; margin: 1em auto; padding: 0.5em;'); // might do this for non-editable also

      formata.forEach(function(field, index) {
        let fieldValue = row[index];
        // if (field && formata[index]) {
        if (formata[index]) {
          let inputElement = document.createElement('input');
          let rtn = null;
          let label = formata[index][0];
          let func = formata[index][1] || null;
          if (label !== false) {  // label explicitly false also supresses display of value
            if (label !== '' && label !== 'noLabel') {  // '' and 'noLabel' are redundant
              let labelElement = document.createElement('label');
              labelElement.for = label;
              labelElement.innerHTML = label;
              form.appendChild(labelElement);
            }
            inputElement.type = 'text';
            inputElement.size = '28';
            inputElement.value = fieldValue;
            inputElement.name = label; // or should this be "id"?

            inputElement.addEventListener('change', function(evt) {
              row[index] = this.value;
            });
            // This works if it's a feature but not if it's editable server-side data
            // need another format option to accommodate that
            inputElement.addEventListener('input', function(evt) {
              row[index] = this.value;
              // if (attribute === 'label') {  // nice feature that updates the label on the map as the user types
              //   let style = feature.getStyle();
              //   if (style) {
              //     style[0].getText().setText(this.value);
              //   }
              // }
            });

            form.appendChild(inputElement);
          }
          if (func) { // TODO shared func between editable & non-editable
            try {
              rtn = func(fieldValue, inputElement);
            }
            catch(err) {
              console.error(err);
              console.info(field);  // eslint-disable-line no-console
            }
            if (rtn) {
              span = document.createElement('span');
              if (typeof rtn === 'string') {
                span.innerHTML = ' ' + rtn;
              } else {
                span.appendChild(rtn);
              }
              form.appendChild(span);
            }
          }
          if (label !== false || rtn) {
            form.appendChild(document.createElement('br'));
          }
        }
      });  // forEach field

      if (action) { // add a delete button and a save button
        let div = document.createElement('div');
        // div.style['margin-left'] = '5em';
        let inputElement = document.createElement('input');
        inputElement.type = 'button';
        inputElement.className = 'rwg-btn';
        inputElement.value = 'Delete';
        inputElement.addEventListener('click', function(evt) {
          action(evt, row);
        });
        div.appendChild(inputElement);

        inputElement = document.createElement('input');
        inputElement.type = 'button';
        inputElement.className = 'rwg-btn';
        inputElement.value = 'Save';
        inputElement.style.margin = 'auto 5em';
        inputElement.addEventListener('click', function(evt) {
          action(evt, row);
        });
        div.appendChild(inputElement);
        form.appendChild(div);
      }
      content.appendChild(form);

    });  // forEach row

  } else {  // non-editable

    records.forEach(function(row) {
      ul = document.createElement('ul');
      ul.setAttribute('data-id', row[0]);

      // this is just to eliminate errors in Leaflet development
      if (typeof rwg.map.getLayerByTitle === 'function') {
        ul.onmouseenter = function() {
          let feature = rwg.map.getLayerByTitle('lyrVector').getSource().getFeatureById(this.getAttribute('data-id'));
          if (feature) {
            let style0 = JSON.stringify(feature.getStyle());
            this.style.background = '#eee';
            feature.set('style0', style0);   // save the sytle for later
            // feature.setStyle(rwg.hoverStyle);
            feature.setStyle(rwg.styles.get('hoverStyle'));
          }
        }; // fires only on this <ul> element

        ul.onmouseleave = function() {
          let feature = rwg.map.getLayerByTitle('lyrVector').getSource().getFeatureById(this.getAttribute('data-id'));
          if (feature) {
            this.style.background = '';
            let style0 = JSON.parse(feature.get('style0')); // fetch the original style
            feature.setStyle(style0);
            feature.set('style0'); // remove the attribute
          }
        };
      }

      row.forEach(function(field, index) {
        // let fieldFormat = formata[index];
        if (field && formata[index]) {
          let rtn = null;
          let label = formata[index][0];
          let func = formata[index][1] || null;
          li = document.createElement('li');
          if (label !== false) {  // label explicitly false also supresses display of value
            if (label !== '' && label !== 'noLabel') {  // '' and 'noLabel' are redundant
              span = document.createElement('span');
              span.style.color = 'grey';
              span.appendChild(document.createTextNode(label + ': '));
              li.appendChild(span);
            }
            span = document.createElement('span');
            span.innerHTML = field;
            li.appendChild(span);
          }
          if (func) {
            try {
              rtn = func(field, row);
            }
            catch(err) {
              console.error(err);  // eslint-disable-line no-console
              console.info(field);  // eslint-disable-line no-console
            }
            if (rtn) {
              span = document.createElement('span');
              if (typeof rtn === 'string') {
                span.innerHTML = ' ' + rtn;
              } else {
                span.appendChild(rtn);
              }
              li.appendChild(span);
            }
          }
          if (li.innerHTML) { // is this a reliable test?
            ul.appendChild(li);
          }
        }
      });  // forEach field

      content.appendChild(ul);
    });  // forEach row
  } // not editable


  if (footer) {
    if (footer instanceof HTMLElement) {
      content.appendChild(footer);
    } else {
      para = document.createElement('p');
      para.style.margin = '0.75em';
      para.innerHTML = footer;
      content.appendChild(para);
    }
  }

  return content;
}
